/**
 * What a non-Administrator sees on an account whose HIPAA agreement is
 * not accepted yet: the agreement can only be accepted by an
 * Administrator, and the only way on is OK, which signs the user out
 * or moves them to their next account.
 *
 * Replaces the legacy InfoDialog for this one use. Not dismissable by
 * backdrop or Escape, same as before.
 */
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogFooterActions,
  DialogHeader,
  DialogTitle,
  DialogTitleBlock,
} from '@shared/ui';

const HipaaAdminRequiredDialog = ({ open, onClose }) => {
  const { dialogs, btn } = useSelector(state => state.i18n);

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={480}
      ariaLabel={dialogs.hipaaAgreement}
      header={
        <DialogHeader>
          <DialogTitleBlock>
            <DialogTitle>{dialogs.hipaaAgreement}</DialogTitle>
            <DialogDescription>{dialogs.administratorMustAccept}</DialogDescription>
          </DialogTitleBlock>
        </DialogHeader>
      }
      footer={
        <DialogFooter>
          <DialogFooterActions>
            <Button variant="primary" onClick={onClose}>
              {btn.ok}
            </Button>
          </DialogFooterActions>
        </DialogFooter>
      }
    />
  );
};

export default HipaaAdminRequiredDialog;
